<template>
	<main>
		<banner :title="getText('project-proposals')"/>

		<section class="bg-gray-700">
			<div class="container mx-auto px-4 pb-16 md:pb-48">
				<div class="flex flex-wrap w-full">
					<div class="pt-12 w-full">
						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('baku-title') }}</h2>
						</div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('baku-address')}}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('about-duties') }}: {{ getText('baku-duties') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('project-type') }}: {{ getText('baku-type') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('object-total-area') }}: 762 000 m²</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-1') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-2') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-3') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-4') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-5') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-6') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-7') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-8') }}</p>
                  <p class="text-white font-semibold mb-4">{{ getText('baku-9') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16">
                <slider :images="slidesBaku"></slider>
              </div>
            </div>

            <div class="block mb-4">
              <h2 class="text-white font-semibold text-3xl">{{ getText('block-title') }}</h2>
            </div>
            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('block-address')}}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('block-client')}}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2020</p>

                  <p class="text-white font-semibold mb-4">{{ getText('project-man') }}: {{ getText('w-place-5') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('block-author') }}</p>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mt-4">{{ getText('building-description') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('block-building-1') }}:</span>
                      </li>
                      <li class="pl-4">
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('block-inside') }}: 23.4 m²</span>
                      </li>
                      <li class="pl-4">
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('block-terrace') }}: 15.2 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('block-building-2') }}:</span>
                      </li>
                      <li class="pl-4">
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('block-inside') }}: 33.8 m²</span>
                      </li>
                      <li class="pl-4">
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('block-terrace') }}: 19.6 m²</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16">
                <slider :images="slidesBlock"></slider>
              </div>
            </div>

						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('pirags-title') }}</h2>
						</div>
						<div class="flex flex-wrap w-full pb-24">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">
									<p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('pirags-address')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('pirags-client')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2020</p>

									<div class="text-white font-semibold">
										<p class="text-white font-semibold mt-4">{{ getText('object-data') }}</p>
										<ul>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-construction-area') }}: 270 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('useful-area') }}: 115 m²</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16">
								<slider :images="slidesPirags"></slider>
							</div>
						</div>

						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('proposals-estrade') }}</h2>
						</div>
						<div class="flex flex-wrap w-full pb-24">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">
									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('estrade-client')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('estrade-location')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('development-time') }}: {{ getText('estrade-development-time')}}</p>

									<div class="text-white font-semibold">
										<p>{{ getText('project-group') }}:</p>
										<ul>
											<li v-for="group in group1" :key="group" class="flex">
												<i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
												<span class="pt-2">{{ getText(group) }}</span>
											</li>
										</ul>
									</div>

									<div class="text-white font-semibold">
										<p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
										<ul>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-total-ground-area') }}: 27 0845 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-construction-area') }}</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('estrade-size-1') }}: 540 m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('estrade-size-2') }}: 1 618,3  m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('estrade-size-3') }}: 217.1 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('level-area') }}: 2143,7</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('floor-count') }}: 1</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16">
								<slider :images="slidesEstrade"></slider>
							</div>
						</div>

						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('tv3-title') }}</h2>
						</div>
						<div class="flex flex-wrap w-full pb-24">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">
									<p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('tv3-address')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('tv3-client')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('development-time') }}: {{ getText('tv3-duration')}}</p>

									<div class="text-white font-semibold">
										<p>{{ getText('project-group') }}:</p>
										<ul>
											<li v-for="group in partners2" :key="group" class="flex">
												<i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
												<span class="pt-2">{{ getText(group) }}</span>
											</li>
										</ul>
									</div>

									<div class="text-white font-semibold">
										<p class="text-white font-semibold mt-4">{{ getText('object-data') }}</p>
										<ul>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-total-ground-area') }}: 12 340 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('level-area') }}: 5 369 m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-area-1') }}: 785 m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-area-2') }}: 1 554 m²</span>
											</li>
											<li class="pl-4">
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-area-3') }}: 3 030 m²</span>
											</li>
										</ul>

										<p class="text-white font-semibold mt-4">{{ getText('floor-count') }}</p>
										<ul>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-floor-1') }}: 2</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-floor-2') }}: 3</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('tv3-floor-3') }}: 2</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesTv3"></slider>
							</div>
						</div>

						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('saulkrasti-raina-title') }}</h2>
						</div>
						<div class="flex flex-wrap w-full pb-24">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">
									<p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('saulkrasti-raina-address')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('estrade-client')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2012</p>

									<p class="text-white font-semibold mb-4">{{ getText('project-man') }}: {{ getText('sia-arhetips') }}</p>

									<p class="text-white font-semibold mb-4">{{ getText('saulkrasti-raina-authors') }}</p>

									<p class="text-white font-semibold mb-4">{{ getText('saulkrasti-raina-desc-1') }}</p>
									<p class="text-white font-semibold mb-4">{{ getText('saulkrasti-raina-desc-2') }}</p>
									<p class="text-white font-semibold mb-4">{{ getText('saulkrasti-raina-desc-3') }}</p>
									<p class="text-white font-semibold mb-4">{{ getText('saulkrasti-raina-desc-4') }}</p>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesRaina"></slider>
							</div>
						</div>

						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('industrial-title') }}</h2>
						</div>
						<div class="flex flex-wrap w-full pb-24">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">
									<p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('industrial-address')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('private-1-2-3-client')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2010</p>

									<p class="text-white font-semibold mb-4">{{ getText('project-man') }}: {{ getText('sia-arhetips') }}</p>

									<p class="text-white font-semibold mb-4">{{ getText('project-group') }}: M.Mežulis, J.Saknītis, A.Arbidāns</p>
								</div>

								<div class="text-white font-semibold">
									<p class="text-white font-semibold mt-4">{{ getText('object-description') }}</p>
									<ul>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-total-ground-area') }}: 993 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-construction-area') }}: 254 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('on-earth-floor-count') }}: 4</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('on-earth-floor-area') }}: 812 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('basement-floor-area') }}: 219 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('new-rooms-area') }}: 1 031 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('reconstructable-rooms-area') }}: 20 m²</span>
										</li>
									</ul>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesIndustrial"></slider>
							</div>
						</div>

						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('stopini-title') }}</h2>
							<h3 class="text-white font-semibold text-2xl">{{ getText('stopini-title-2') }}</h3>
						</div>
						<div class="flex flex-wrap w-full pb-24">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">
									<p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('stopini-address')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('stopini-client')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('development-time') }}: {{ getText('stopini-development') }}</p>

									<p class="text-white font-semibold mb-4">{{ getText('project-man') }}: {{ getText('w-place-5') }}</p>

									<p class="text-white font-semibold mb-4">{{ getText('project-group') }}: M.Mežulis, J.Saknītis, A.Arbidāns, Z.Zanele</p>

									<div class="text-white font-semibold">
										<p class="text-white font-semibold mt-4">{{ getText('building-description') }}</p>
										<ul>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-total-ground-area') }}: 35 045 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-bulding') }}: 4 295 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-construction-area') }}: 3 777 m²</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('object-volume') }}: 23 570 m³</span>
											</li>
											<li>
												<i class="fas fa-caret-up pr-4 pl-4"></i>
												<span>{{ getText('floor-count') }}: 2</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesStopini"></slider>
							</div>
						</div>

						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('vikingi-title') }}</h2>
						</div>
						<div class="flex flex-wrap w-full pb-24">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">
									<p class="text-white font-semibold mb-4">{{ getText('location') }}: {{ getText('vikingi-address')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('private-1-2-3-client')}}</p>

									<p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2005</p>

									<p class="text-white font-semibold mb-4">{{ getText('project-man') }}: {{ getText('sia-arhetips') }}</p>

									<p class="text-white font-semibold mb-4">{{ getText('project-group') }}: M.Mežulis, J.Saknītis, A.Arbidāns</p>
								</div>

								<div class="text-white font-semibold">
									<p class="text-white font-semibold mt-4">{{ getText('object-description') }}</p>
									<ul>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-total-ground-area') }}: 3 143 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('vikingi-stuff') }}: 467 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-construction-area') }}:  1 716 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('level-area') }}: 4 584 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-cubic') }}: 17 175 m³</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('floor-count') }}: 4</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('apartment-count') }}: 44</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('apartment-area') }}: 3 676 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('parking-spaces') }}: 44</span>
										</li>
									</ul>
								</div>

								<div class="block my-4">
									<p class="text-white font-semibold mb-4">{{ getText('vikingi-desc-1') }}</p>
									<p class="text-white font-semibold mb-4">{{ getText('vikingi-desc-2') }}</p>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesVikingu"></slider>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
	import {PROPOSALS_GROUP_1, TV3_PARTNERS} from '../../data/projectPartners'
	import {mapGetters} from "vuex";
	import Slider from '../../components/Slider.vue';
	import Banner from "../Banner";

	export default {
		name: "Proposals",
		data() {
			return {
				group1: PROPOSALS_GROUP_1,
				partners2: TV3_PARTNERS,
				slidesEstrade: [
					'/images/estrade/estrade-1.jpg',
					'/images/estrade/estrade-2.jpg',
					'/images/estrade/estrade-3.jpg',
				],
				slidesTv3: [
					'/images/tv3/tv3-1.jpg',
					'/images/tv3/tv3-2.jpg',
				],
				slidesBlock: [
					'/images/block/block-1.jpg',
					'/images/block/block-2.jpg',
				],
        slidesBaku: [
          '/images/baku/baku (1).jpg',
          '/images/baku/baku (2).jpg',
          '/images/baku/baku (3).jpg',
          '/images/baku/baku (4).jpg',
          '/images/baku/baku (5).jpg',
          '/images/baku/baku (6).jpg',
          '/images/baku/baku (7).jpg',
          '/images/baku/baku (8).jpg',
          '/images/baku/baku (9).jpg',
          '/images/baku/baku (10).jpg',
          '/images/baku/baku (11).jpg',
          '/images/baku/baku (12).jpg',
          '/images/baku/baku (13).jpg',
          '/images/baku/baku (14).jpg',
          '/images/baku/baku (15).jpg',
          '/images/baku/baku (16).jpg',
          '/images/baku/baku (17).jpg',
          '/images/baku/baku (18).jpg',
        ],
				slidesPirags: [
					'/images/pirags/pirags-1.jpg',
					'/images/pirags/pirags-2.jpg',
				],
				slidesStopini: [
					'/images/stopini/stopini-1.jpg',
					'/images/stopini/stopini-2.jpg',
					'/images/stopini/stopini-3.jpg',
					'/images/stopini/stopini-4.jpg',
					'/images/stopini/stopini-5.jpg',
					'/images/stopini/stopini-6.jpg',
				],
				slidesRaina: [
					'/images/saulkrasti-raina/saulkrasti-1.jpg',
					'/images/saulkrasti-raina/saulkrasti-2.jpg',
					'/images/saulkrasti-raina/saulkrasti-3.jpg',
					'/images/saulkrasti-raina/saulkrasti-4.jpg',
					'/images/saulkrasti-raina/saulkrasti-5.jpg',
					'/images/saulkrasti-raina/saulkrasti-6.jpg',
					'/images/saulkrasti-raina/saulkrasti-7.jpg',
					'/images/saulkrasti-raina/saulkrasti-8.jpg',
					'/images/saulkrasti-raina/saulkrasti-9.jpg',
					'/images/saulkrasti-raina/saulkrasti-10.jpg',
				],
				slidesIndustrial: [
					'/images/industrial/industrial-1.jpg',
					'/images/industrial/industrial-2.jpg',
					'/images/industrial/industrial-3.jpg',
					'/images/industrial/industrial-4.jpg',
					'/images/industrial/industrial-5.jpg',
					'/images/industrial/industrial-6.jpg',
				],
				slidesVikingu: [
					'/images/vikingu/vikingu-1.jpg',
					'/images/vikingu/vikingu-2.jpg',
					'/images/vikingu/vikingu-3.jpg',
					'/images/vikingu/vikingu-4.jpg',
					'/images/vikingu/vikingu-5.jpg',
					'/images/vikingu/vikingu-6.jpg',
					'/images/vikingu/vikingu-7.jpg',
				]
			}
		},
		computed: {
			...mapGetters(['getText'])
		},
		components: {
			Banner,
			Slider,
		},
	}
</script>

<style scoped>

</style>